import { render, staticRenderFns } from "./BoxPattern.vue?vue&type=template&id=0fcc07e0&scoped=true&"
import script from "./BoxPattern.vue?vue&type=script&lang=js&"
export * from "./BoxPattern.vue?vue&type=script&lang=js&"
import style0 from "./BoxPattern.vue?vue&type=style&index=0&id=0fcc07e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcc07e0",
  null
  
)

export default component.exports